<div fxLayout="column" class="location-filter">
  <div fxLayout="row">
    <div style="height: 40px;">
      <label class="label">Outlet property</label>
      @for (kv of model.outletPropertyItems; track kv) {
        <span class="tag">{{ kv.outletProperty }}: {{ kv.value }}</span>
      }
      <span class="total"> ({{ total }} outlets)</span>
    </div>
    <div fxFlex></div>
    <div class="actions">
      <button mat-button color="primary" matTooltip="Delete outlet property filter" (click)="onDelete()"><mat-icon>delete</mat-icon></button>
    </div>
  </div>
  @if (isError) {
    <div>
      <span>{{error}}</span>
    </div>
  }
  <ngx-datatable  style="height: 300px;" #datatable class="material" [rows]="rows" [columnMode]="ColumnMode.force" [headerHeight]="50" [rowHeight]="45" [scrollbarV]="true">
    <ngx-datatable-column name="State"        cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true" [width]="100">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [title]="row.state">
          @if (row.state === barState.ForReview) {
            <span  >For review</span>
          }
          @if (row.state === barState.Validated) {
            <span  >Validated</span>
          }
          @if (row.state === barState.NewVisible) {
            <span >New (visible)</span>
          }
          @if (row.state === barState.NewHidden) {
            <span  >New (hidden)</span>
          }
          @if (row.state === barState.ForDeletion) {
            <span>For deletion</span>
          }
        </span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Name"         cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [title]="row.name">{{ row.name }}</span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Address"      cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [title]="row.formattedAddress">{{ row.formattedAddress }}</span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Vendor name"  cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [title]="row.vendorName">{{ row.vendorName }}</span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="External id"  cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span [title]="row.externalId">{{ row.externalId }}</span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name=""             cellClass="cell-e" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="true">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div>
          <!-- what is this column? is it a filler? -->
          <!-- <button class="action-button" mat-icon-button (click)="onView(row)" color="primary" matTooltip="View"><mat-icon>visibility</mat-icon></button> -->
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>

